/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type EnableDeviceLogsMutationVariables = Types.Exact<{
  deviceId: Types.Scalars['ID'];
  durationDays: Types.Scalars['Int'];
  durationHours: Types.Scalars['Int'];
}>;


export type EnableDeviceLogsMutation = { __typename: 'Mutation', serviceAdminEnableDeviceLogs: { __typename: 'ServiceAdminDeviceLog', id: string } };


export const EnableDeviceLogsDocument = gql`
    mutation EnableDeviceLogs($deviceId: ID!, $durationDays: Int!, $durationHours: Int!) {
  serviceAdminEnableDeviceLogs(
    deviceId: $deviceId
    durationDays: $durationDays
    durationHours: $durationHours
  ) {
    id
  }
}
    `;
export type EnableDeviceLogsMutationFn = ApolloReactCommon.MutationFunction<EnableDeviceLogsMutation, EnableDeviceLogsMutationVariables>;

/**
 * __useEnableDeviceLogsMutation__
 *
 * To run a mutation, you first call `useEnableDeviceLogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableDeviceLogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableDeviceLogsMutation, { data, loading, error }] = useEnableDeviceLogsMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      durationDays: // value for 'durationDays'
 *      durationHours: // value for 'durationHours'
 *   },
 * });
 */
export function useEnableDeviceLogsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableDeviceLogsMutation, EnableDeviceLogsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnableDeviceLogsMutation, EnableDeviceLogsMutationVariables>(EnableDeviceLogsDocument, options);
      }
export type EnableDeviceLogsMutationHookResult = ReturnType<typeof useEnableDeviceLogsMutation>;
export type EnableDeviceLogsMutationResult = ApolloReactCommon.MutationResult<EnableDeviceLogsMutation>;
export type EnableDeviceLogsMutationOptions = ApolloReactCommon.BaseMutationOptions<EnableDeviceLogsMutation, EnableDeviceLogsMutationVariables>;